export const columns = [
  { id: 'campaignName', label: 'Nome da campanha', minWidth: 270 },
  { id: 'campaignNumber', label: 'Número da campanha', minWidth: 125 },
  { id: 'campaignPeriod', label: 'Vigência da campanha', minWidth: 160 },
  { id: 'status', label: 'Status', minWidth: 145 },
  { id: 'createdBy', label: 'Criado por', minWidth: 50 },
  { id: 'actions', label: '', minWidth: 280 }
]
